// src/pages/Teaching.jsx
import { Link } from "react-router-dom";

export default function Teaching() {
  return (
    <main style={{ padding: "1rem", marginLeft: "1rem", lineHeight: "1.1" }}>
      <h1>Teaching</h1>

      <h3>Fall 2026</h3>
       <p>
        <Link to="/courses/ARHI13182">ARHI 13182: University Seminar</Link>

        <p><Link to="/courses/ARHI43481">ARHI 43481: Slackers, Critics, and Makers</Link></p>

      </p>

       {/* ------------------------------------------------- */}
      <h3>2025-26</h3>
      <p>
        <Link to="/courses/ARHI30482S26">ARHI 30482: Art Now (spring)</Link>
      </p>
      <p>
        <Link to="/courses/ARHI30489S26">ARHI 30489: Art in Chicago (spring)</Link>
      </p>
      <p>
        <Link to="/courses/ARHI13182F25">ARHI 13182: University Seminar (fall)</Link>
      </p>
      <p>
        <Link to="/courses/ARHI43406F25">ARHI 43406: Topics in Contemporary Art (fall)</Link>
      </p>

      {/* ------------------------------------------------- */}
      <h3>2024-25</h3>
      <p><Link to="/courses/ARHI30423S25">ARHI 30423: Global Modern & Contemporary Art (spring)</Link></p>
      <p><Link to="/courses/ARHI43481S25">ARHI 43481: Slackers, Critics, and Makers (spring)</Link></p>
      <p>ARHI 13182: USEM (fall)</p>
      <p><Link to="/courses/ARHI30531F24">ARHI 30531: Art, Vision, and Difference (fall)</Link></p>

      {/* ------------------------------------------------- */}
      <h3>2023-24</h3>
      <p>ARHI 13182: USEM (spring)</p>
      <p>ARHI 43406: Art and the Everyday (spring)</p>
      <p>ARHI 30482: Art Now (fall)</p>
      <p><Link to="/courses/ARHI30489F23">ARHI 30489: Art in Chicago (fall)</Link></p>

      {/* ------------------------------------------------- */}
      <h3>2022-23</h3>
      <p>ARHI 30489: Art in Chicago (spring)</p>
      <p><Link to="/courses/ARHI43406S24">ARHI 43481: Slackers, Critics, and Makers (spring)</Link></p>
      <p>ARHI 13182: Fine Arts University Seminar (fall)</p>
      <p>ARHI 30531: Art, Vision, & Difference (fall)</p>

      {/* ------------------------------------------------- */}
      <h3>2021-22</h3>
      <p>ARHI 30480: Twentieth-Century Art (spring)</p>
      <p>ARHI 30489: Art in Chicago (spring)</p>
      <p>ARHI 30482: Art Now (fall)</p>
      <p>ARHI 43486: Art & the Everyday (fall)</p>

      {/* ------------------------------------------------- */}
      <h3>2020-21</h3>
      <p>ARHI 13182: University Seminar (fall)</p>
      <p>ARHI 30482: Art Now (fall)</p>
      <p>ARHI 30531: Art, Vision, & Difference (spring)</p>
      <p>ARHI 43481: Slackers, Critics, and Makers (spring)</p>

      {/* ------------------------------------------------- */}
      <h3>2019-20</h3>
      <p>ARHI 13182: University Seminar (fall)</p>
      <p>ARHI 30531: Art, Vision, & Difference (fall)</p>
      <p>ARHI 13182: University Seminar (spring)</p>
      <p>ARHI 30489: Art in Chicago (spring)</p>

      {/* ------------------------------------------------- */}
      <h3>2018-19</h3>
      <p>ARHI 13182: University Seminar (fall)</p>
      <p>ARHI 30482: Art Now (fall)</p>
      <p>ARHI 30489: Art in Chicago (spring)</p>
      <p>ARHI 43481: Art & the Everyday (spring)</p>

      {/* ------------------------------------------------- */}
      <h3>2016-17</h3>
      <p>ARHI 20310: Leonardo to Warhol (spring)</p>
      <p>ARHI 30489: Art in Chicago (spring)</p>
      <p>ARHI 43481: Art & the Home (fall)</p>
      <p>ARST 43701: Senior Seminar (fall)</p>

      {/* ------------------------------------------------- */}
      <h3>2015-16</h3>
      <p>ALHN 13901: 20th-Century Art (spring)</p>
      <p>ARHI 30482: Topics in Contemporary Art — Art Now (spring)</p>
      <p>ARHI 20310: Leonardo to Warhol (fall)</p>
      <p>ARST 43701: Senior Seminar (fall)</p>

      {/* ------------------------------------------------- */}
      <h3>2014-15</h3>
      <p>ARHI 30531: Art, Vision, & Difference (fall)</p>
      <p>ARST 43701: Senior Seminar (fall)</p>
      <p>ALHN 13902: Introduction to the History of Art (spring)</p>
      <p>ARHI 43481: Art & the Home (spring)</p>

      {/* ------------------------------------------------- */}
      <h3>2013-14</h3>
      <p>ARHI 13182: Fine-Arts University Seminar (fall)</p>
      <p>ARHI 20530: Art, Vision, & Difference (fall)</p>
      <p>ARHI 13182: Fine-Arts University Seminar (spring)</p>
      <p>ALHN 13901: Honors Seminar in 20th-Century Art (spring)</p>

      {/* ------------------------------------------------- */}
      <h3>Other courses taught at Notre Dame</h3>
      <p>ALHN 13901 Honors Seminar: Twentieth-Century Art</p>
      <p>ARHI 20440-20441 Twentieth-Century Art 1900-1980</p>
      <p>ARHI 30480 Topics in Contemporary Art: “Art Now” (1980-2003)</p>
      <p>ARHI 30530  Art, Feminism, and Gender since 1960</p>
      <p>ARHI 43480 Topics in Contemporary Art: “Art and the Document”</p>
      <p>ARHI 43480 Topics in Contemporary Art: “Unmonumental”</p>
      <p>ARHI 63570 Graduate Seminar</p>

      {/* ------------------------------------------------- */}
      <h3>Courses taught at McGill University</h3>
      <p>ARTH 339B Foundations of Contemporary Art</p>
      <p>ARTH 360A Photography and Art</p>
      <p>ARTH 353B Selected Topics: “Art Now”</p>
      <p>ARTH 447A Independent Study: German Painting & Politics in the 20th Century</p>
      <p>ARTH 447B Independent Study: YBA, Celebrity, & Sensation in Contemporary Art</p>
    </main>
  );
}
